import React, { useState, useEffect } from "react";
import { Paginator } from "../../../layout/Paginator/Paginator";
import { Search } from "../../../layout/Table/Search";
import { TableComponent } from "../../orderManagement/table/Table";
import { Messages } from "../../../../components/layout/Messages/Messages";
import { ACL } from '../../../../config/constants';
import { RowsPerPage } from "../../../layout/Table/RowsPerPage";
import { store } from '../../../../store/store';
import { hideNotification } from '../../../../store/actions/notification';
import { ListToolbar } from '../../../layout/Workspace';

function OrganizationOrdersTab(props) {
  const [sortDirection, setSortDirection] = useState(null);
  const [sortField, setSortField] = useState(null);
  const [searchText, setSearchText] = useState(null);
  const { organization, getOrganizationOrders, orders, metaOrders, rowsPerPageOrders, setRowsPerPageOrders } = props;

  useEffect(() => {
    if (organization && getOrganizationOrders) {
      getOrganizationOrders(organization.id, 1, sortField, sortDirection, searchText);
    }

    return () => {
      store.dispatch(hideNotification());
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [rowsPerPageOrders]);

  /**
   * Apply sort by appliedSortField
   * @param {string} appliedSortField
   */
  function applySort(appliedSortField) {
    let newSortDirection = "";

    if (sortField) {
      if (sortField === appliedSortField) {
        newSortDirection = sortDirection === "asc" ? "desc" : "asc";
      } else {
        newSortDirection = "asc";
      }
    } else {
      newSortDirection = "asc";
    }

    setSortField(appliedSortField);
    setSortDirection(newSortDirection);

    getOrganizationOrders(organization.id, metaOrders.current_page, appliedSortField, newSortDirection, searchText, true);
  }

  return (
    <section className="organization-detail-section">
      <div className="organization-detail-section__messages">
        <Messages />
      </div>
      <ListToolbar
        className="organization-detail-list-toolbar"
        search={ACL.CLIENT.ORDERS.SEARCH.hasAccess() ? (
          <Search
              search={(searchText) => {
                setSearchText(searchText);
                getOrganizationOrders(organization.id, 1, null, null, searchText, true);
              }}
              id="orders"
          />
        ) : null}
      />
      <div className="organization-detail-table organization-orders-table">
        <TableComponent
          applySort={(sortField) => applySort(sortField)}
          orders={orders}
          actionCallback={(useState) => {
            if (useState) {
              getOrganizationOrders(
                organization.id,
                metaOrders.current_page,
                sortField,
                sortDirection,
                searchText
              );
            }
            getOrganizationOrders(organization.id);
          }}
        />
      </div>
      <Paginator
        meta={metaOrders}
        settings={(
          <RowsPerPage
            changeRowsPerPage={(rowsPerPage) => {
              setRowsPerPageOrders(rowsPerPage);
            }}
            id="orders"
          />
        )}
        changePage={(page) =>
          getOrganizationOrders(organization.id, page, sortField, sortDirection, searchText, true)
        }
      />
    </section>
  );
}

export { OrganizationOrdersTab };
